<template>
  <div>
    <button class="btn form-control btn btn-dark" disabled>
      <span class="spinner-grow spinner-grow-sm"></span>
        در حال پردازش اطلاعات
    </button>
     <input type="hidden">
  </div>
</template>



